import React from 'react'
import ServiceBanner from '../../components/ServiceComponents/ServiceBanner'
import OurServicesLoop from '../../components/ServiceComponents/OurServicesLoop'

const Service = () => {
    return (
        <div>
            <ServiceBanner />
            <OurServicesLoop />
        </div>
    )
}

export default Service
